import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { servicesData } from "../data/servicesData";
import ServiceCard from "../components/common/ServiceCard";
import styles from "./Services.module.css";
import checkUpImage from "../././assets/health-services.jpg";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Our Services | Muigai Medical Center</title>
        <meta
          name="description"
          content="Explore our comprehensive medical services: general consultation, specialist appointments, diagnostics, laboratory, minor surgery, rehabilitation, vaccinations, and health check-ups."
        />
      </Helmet>

      {/* Hero Banner */}
      <section
        style={{ backgroundImage: `url(${checkUpImage})` }}
        className={styles.heroBanner}
      >
        <div className={styles.heroOverlay}></div>
        <div className="container">
          <motion.div
            className={styles.heroContent}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <motion.div className={styles.sectionTag} variants={fadeInUp}>
              OUR SERVICES
            </motion.div>
            <motion.h1 variants={fadeInUp}>
              Comprehensive Healthcare Services
            </motion.h1>
            <motion.p className={styles.heroSubtitle} variants={fadeInUp}>
              From routine check-ups to specialized care – we offer a full range
              of medical services under one roof.
            </motion.p>
          </motion.div>
        </div>
        <div className={styles.heroBackground}>
          <div
            className={styles.floatingCircle}
            style={{ top: "15%", left: "10%", width: "120px", height: "120px" }}
          />
          <div
            className={styles.floatingCircle}
            style={{
              bottom: "20%",
              right: "15%",
              width: "80px",
              height: "80px",
            }}
          />
          <div
            className={styles.floatingCircle}
            style={{ top: "60%", left: "20%", width: "60px", height: "60px" }}
          />
        </div>
      </section>

      {/* Services Grid */}
      <motion.section
        className={styles.servicesSection}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={staggerContainer}
      >
        <div className="container">
          <div className={styles.servicesGrid}>
            {servicesData.map((service) => (
              <motion.div
                key={service.id}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
                }}
              >
                <ServiceCard
                  id={service.id}
                  title={service.title}
                  description={service.shortDesc}
                  icon={service.icon}
                  bgImage={service.bgImage}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Services;
